(() => {
  if (window.sdPeakCollectionsReady) return;
  window.sdPeakCollectionsReady = true;
  let mode = 'product';
  try { mode = sessionStorage.getItem('sd:collection-media') || mode; } catch {}
  const sync = () => {
    document.body.classList.toggle('sd-collection-detail-view', mode === 'detail');
    document.querySelectorAll('[data-sd-collection-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sdCollectionView === mode)));
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sd-collection-view]');
    if (!button) return;
    mode = button.dataset.sdCollectionView;
    try { sessionStorage.setItem('sd:collection-media', mode); } catch {}
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('shopify:section:load', sync);
  let queued = false;
  new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; sync(); }); } }).observe(document.querySelector('main') || document.body, {childList:true,subtree:true});
})();
